module.exports = {"430923101":"清塘铺镇","430923103":"仙溪镇","430923105":"长塘镇","430923106":"小淹镇","430923108":"羊角塘镇","430923109":"冷市镇","430923111":"奎溪镇","430923112":"烟溪镇","430923113":"渠江镇","430923114":"平口镇","430923115":"柘溪镇","430923116":"乐安镇","430923117":"滔溪镇","430923118":"梅城镇","430923119":"大福镇","430923120":"马路镇","430923121":"东坪镇","430923122":"江南镇","430923200":"高明乡","430923206":"龙塘乡","430923209":"田庄乡","430923211":"南金乡","430923212":"古楼乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/430923.json
// module id = 1888
// module chunks = 0